
export default {
  props: {
    type: {
      type: String,
      default: 'aanbesteding'
    },

    platforms: {
      type: Array,
      default: () => ['url', 'email', 'linkedIn', 'twitter']
    },

    url: {
      type: String,
      default: undefined
    },

    messageTemplate: {
      type: String,
      default () {
        return `
        Kijk wat ik heb gevonden op Altura:
        {{url}}
        Ik hoor graag wat je er van vindt!`
          .replace(/ {6}/gm, '')
          .trim();
      }
    }
  },
  data () {
    return {
      copied: false
    };
  },
  computed: {
    shareUrl () {
      return this.url ?? `https://${location.host + this.$route.path}`;
    },

    linkedInUrl () {
      return `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(this.shareUrl)}`;
    },

    twitterUrl () {
      const body = this.messageTemplate.replace('{{url}}', this.shareUrl);
      return `http://twitter.com/intent/tweet?text=${encodeURIComponent(body)}&hashtags=altura`;
    },

    shareAPISupported () {
      return 'share' in navigator;
    },

    mailtoLink () {
      const body = this.messageTemplate.replace('{{url}}', this.shareUrl);

      return encodeURI(`mailto:?subject=${this.type} gevonden op Altura&body=${body}`);
    }
  },
  methods: {
    translate (key, fallback) {
      if (this.$t) { return this.$t(key) ?? fallback; }

      return fallback;
    },

    share () {
      navigator.share({
        url: this.shareUrl,
        title: `${this.type} ${this.translate('share', 'delen').toLowerCase()}`,
        text: this.translate('share-text', 'Deel deze { type } met je collegas.').replace('{ type }', this.type)
      });
    },

    copyLink () {
      if ('clipboard' in navigator) {
        navigator.clipboard.writeText(this.shareUrl);
        this.copied = true;
        return;
      }

      this.$refs.shareTextbox.select();
      window.document.execCommand('copy');
      this.copied = true;
    }
  }
};
